import { Inject, Injectable, Optional, InjectionToken } from '@angular/core';
import { Response } from 'express';

export const RESPONSE = new InjectionToken<Response>('RESPONSE');

@Injectable({
    providedIn: 'root'
})
export class ServerResponseService {

    constructor(@Optional() @Inject(RESPONSE) private readonly _response: Response) {
    }

    public setStatus(code: number, message?: string): void {
        if (this._response) {

            this._response.statusCode = code;
            if (message) {
                this._response.statusMessage = message;
            }
        }
    }
}